// extracted by mini-css-extract-plugin
export default {"wrapper":"ModalReport_wrapper__GmFUF","cancelBtn":"ModalReport_cancelBtn__hVT1L"};